import { ChakraTheme } from '@chakra-ui/react';
import { rem } from 'polished';

const values = [2, 4, 6, 8, 12, 16, 24, 28, 32, 40, 48, 64];

export const radii: ChakraTheme['radii'] = values.reduce(
  (map, px) => ({ ...map, [`radius.${px}`]: rem(px) }),
  {},
);
